import { useContext } from 'react'
import {
  InfoAlertContext,
  InfoAlertContextInterface,
} from './InfoAlertContextProvider'

export const useInfoAlertContext = (): InfoAlertContextInterface =>
  useContext(InfoAlertContext)
